<template>
  <div class="animated fadeIn">
    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <div slot="header">
        <i class="icon-note"></i> Warehouse Detail
      </div>

      <b-card-body>
        <b-form id="employeeForm" validated novalidate @submit="submitAdd">
          <div v-if="loading == true">
            <div class="sk-spinner sk-spinner-pulse"></div>
            <p class="text-center" style="color: #CCC;">Please wait . . .</p>
          </div>

          <div v-else>
            <b-row>
              <b-col sm="3">
                <b-form-group label-for="name" label="Nama Gudang">
                  <b-form-input
                    id="name"
                    type="text"
                    v-model="$v.warehouseForm.name.$model"
                    :state="!$v.warehouseForm.name.$invalid"
                    required
                    placeholder="Nama Gudang"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nama Gudang harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="prefix" label="Inisial">
                  <b-form-input
                    id="prefix"
                    type="text"
                    v-model="$v.warehouseForm.prefix.$model"
                    :state="!$v.warehouseForm.prefix.$invalid"
                    required
                    placeholder="Prefix"
                  ></b-form-input>
                  <b-form-invalid-feedback>Inisial harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="related_gt" label="Cakupan Konsumen GT">
                  <multi-select
                    :options="listCoverageGT"
                    :selected-options="item_related_gt"
                    placeholder="-- Harap pilih salah satu --"
                    v-model="$v.warehouseForm.related_gt.$model"
                    :isError="$v.warehouseForm.related_gt.$invalid"
                    @select="onSelectGT"
                  ></multi-select>
                  <!-- <div
                    v-if="warehouseForm.related_gt === null || warehouseForm.related_gt.length === 0"
                    class="invalid-feedback-custom"
                  >Group konsumen GT harus di isi.</div> -->
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="related_non_gt" label="Cakupan Konsumen Non GT">
                  <multi-select
                    :options="listCoverageNonGT"
                    :selected-options="item_related_non_gt"
                    placeholder="-- Harap pilih salah satu --"
                    v-model="$v.warehouseForm.related_non_gt.$model"
                    :isError="$v.warehouseForm.related_non_gt.$invalid"
                    @select="onSelectNonGT"
                  ></multi-select>
                  <!-- <div
                    v-if="warehouseForm.related_non_gt === null || warehouseForm.related_non_gt.length === 0"
                    class="invalid-feedback-custom"
                  >Group konsumen Non GT harus di isi.</div> -->
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="6">
                <b-form-group label-for="address" label="Alamat">
                  <b-form-textarea
                    id="address"
                    :rows="3"
                    :max-rows="6"
                    v-model="$v.warehouseForm.address.$model"
                    :state="!$v.warehouseForm.address.$invalid"
                  ></b-form-textarea>
                  <b-form-invalid-feedback>Alamat harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="6">
                <b-form-group label-for="description" label="Description">
                  <b-form-textarea
                    id="description"
                    :rows="3"
                    :max-rows="6"
                    v-model="$v.warehouseForm.description.$model"
                    :state="!$v.warehouseForm.description.$invalid"
                  ></b-form-textarea>
                  <b-form-invalid-feedback>Description harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="12">
                <div slot="footer" class="text-right">
                  <b-button type="button" size="sm" variant="danger" @click="back">
                    <i class="fa fa-undo"></i> Back
                  </b-button>&nbsp;
                  <b-button
                    type="submit"
                    size="sm"
                    variant="primary"
                    :disabled="$v.warehouseForm.$invalid"
                  >
                    <i class="fa fa-save"></i> Save
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-form>
      </b-card-body>
    </b-card>

    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <b-tabs>
        <b-tab title="Produk" active>
          <stock-product
            :warehouse-id="warehouseId"
          ></stock-product>
        </b-tab>

        
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect, MultiSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";
import StockProduct from "./stock/StockProduct.vue";

export default {
  name: "warehouse",
  components: { globalTable, ModelSelect, MultiSelect, loading, StockProduct },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      warehouse: [],
      listCoverageNonGT: [],
      listCoverageGT: [],
      loading: false,
      loadingSubmit: false,
      item_related_gt: [],
      item_related_non_gt: [],
      isEdit: false,
      warehouseForm: interfaces.warehouse
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations: {
    warehouseForm: {
      name: { required },
      prefix: { required },
      related_non_gt: {  },
      related_gt: {  },
      address: {},
      description: {}
    }
  },
  computed: {
      warehouseId: function() {
        let route = this.$route.path.split("/");
        return route[4];
      }
  },
  methods: {
    init: function(id) {
      this.loading = true;
      this.getAllWarehouseDetail(id);
      this.getDropdown();
    },
    getDropdown: function() {
      this.axios
        .get("web/dropdown/warehouse-related/")
        .then(response => {
          this.listCoverageNonGT = response.data.coverage_non_gt;
          this.listCoverageGT = response.data.coverage_gt;
        })
        .catch(error => {})
        .finally(() => {});
    },
    getAllWarehouseDetail(id) {
      this.axios
        .get("web/warehouse/all/" + id)
        .then(response => {
          let data = response.data.data[0];
          this.item_related_gt = data.recreate_related_gt;
          this.item_related_non_gt = data.recreate_related_non_gt;
          this.warehouseForm = data;
          this.warehouseForm.related_non_gt = data.recreate_related_non_gt;
          this.warehouseForm.related_gt = data.recreate_related_gt;
        })
        .catch(error => {
          this.expired(error, "Get Detail");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSelectGT(items, lastSelectItem) {
      this.item_related_gt = items;
      this.warehouseForm.related_gt = items;
    },
    onSelectNonGT(items, lastSelectItem) {
      this.item_related_non_gt = items;
      this.warehouseForm.related_non_gt = items;
    },
    back: function() {
      this.$router.go(-1);
    },
    submitAdd: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda merubah gudang ini ?")) {
        this.loadingSubmit = true;
        this.axios
          .put("web/warehouse/update/", this.warehouseForm)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Ubah Gudang",
                message: response.data.message
              });
            }
          })
          .catch(error => {
            this.expired(error);
          })
          .finally(() => {
            this.loadingSubmitModal = false;
            //let route = this.$route.path.split("/");
            this.init(this.warehouseId);
          });
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init(this.warehouseId);
  }
};
</script>

<style>
</style>
